module.exports = __webpack_public_path__ + "static/media/nav-icon-playbooks.3cfe9eab.svg";